import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { SelectItem } from 'primeng/primeng';
import { CustomerUiService } from '../../../customers/services/customer-ui.service';
import * as utils from '../../../helpers/utils';
import { AnnexurePrintConfig } from '../../../modals/billings/annexure-print-config';
import { PrintConfig } from '../../../modals/billings/print-config';
import { InvoiceFormatEnum } from '../../constants/invoice-format-enum';

/**
 * @description for print pannel
 * @author Pulkit Bansal
 * @date 2019-10-19
 * @export
 * @class PrintPannelLayout
 */
@Component({
    selector: 'sib-print-pannel-layout',
    templateUrl: './print-pannel-layout.component.html',
    styleUrls: ['./print-pannel-layout.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class PrintPannelLayoutComponent implements OnInit {

    @Input() showSave: boolean = true;
    @Input() showPreview: boolean = true;
    @Input() showPrint: boolean = true;
    @Input() showInvoiceFormat: boolean = true;
    @Input() disableInvoiceFormatDropdown: boolean = false;
    @Input() annexureMenu: boolean = false;

    _printConfig: PrintConfig = new PrintConfig();
    @Input() set printConfig(printConfig) {
        if (printConfig) {
            if (printConfig.original !== undefined && printConfig.original !== null) {
                this._printConfig.original = printConfig.original;
            } else {
                this._printConfig.original = false;
            }
            if (printConfig.withLetterHead !== undefined && printConfig.withLetterHead !== null) {
                this._printConfig.withLetterHead = printConfig.withLetterHead;
            } else {
                this._printConfig.withLetterHead = false;
            }

            if (printConfig.withChildren !== undefined && printConfig.withChildren !== null) {
                this._printConfig.withChildren = printConfig.withChildren;
            } else {
                this._printConfig.withChildren = false;
            }

        } else {
            this._printConfig.original = false;
            this._printConfig.withLetterHead = false;
            this._printConfig.withChildren = false;
        }
        // this._printConfig = printConfig;
    }

    get printConfig() {
        return this._printConfig;
    }

    _selectedInvoiceFormat: any;
    @Input() set selectedInvoiceFormat(selectedInvoiceFormat) {
        this._selectedInvoiceFormat = selectedInvoiceFormat;
    }

    get selectedInvoiceFormat() {
        return this._selectedInvoiceFormat;
    }

    _annexurePrintConfig: AnnexurePrintConfig = new AnnexurePrintConfig();
    @Input() set annexurePrintConfig(printConfig) {
        if (printConfig) {

            if (printConfig.withOtherWorks !== undefined && printConfig.withOtherWorks !== null) {
                this._annexurePrintConfig.withOtherWorks = printConfig.withOtherWorks;
            } else {
                this._annexurePrintConfig.withOtherWorks = false;
            }

            if (printConfig.withUnits !== undefined && printConfig.withUnits !== null) {
                this._annexurePrintConfig.withUnits = printConfig.withUnits;
            } else {
                this._annexurePrintConfig.withUnits = false;
            }
        } else {
            this._annexurePrintConfig.withOtherWorks = false;
            this._annexurePrintConfig.withUnits = false;
        }
        // this._printConfig = printConfig;
    }

    get annexurePrintConfig() {
        return this._annexurePrintConfig;
    }

    @Output() eEmitSelectedInvoiceFormat: EventEmitter<any> = new EventEmitter();

    @Output() eEmitSavePrintInstructions: EventEmitter<any> = new EventEmitter();

    @Output() eEmitPreviewPrintItems: EventEmitter<any> = new EventEmitter();

    @Output() eEmitPrintItems: EventEmitter<any> = new EventEmitter();

    @Output() eEmitChangedPrintType: EventEmitter<any> = new EventEmitter();

    @Output() eEmitChangedPrintLetterHead: EventEmitter<any> = new EventEmitter();

    @Output() eEmitChangedChildrenVisibility: EventEmitter<any> = new EventEmitter();

    @Output() eEmitChangedAnnexureOtherWorks: EventEmitter<any> = new EventEmitter();

    @Output() eEmitChangedAnnexureUnitsVisibility: EventEmitter<any> = new EventEmitter();


    invoiceFormats: SelectItem[] = [];
    userRole: string;

    constructor(
        private customerUiService: CustomerUiService,
        private changeDetectorRef: ChangeDetectorRef,
    ) { }

    ngOnInit() {
        this.setUserRole();
        this.setInvoiceFormatDropdown();
    }

    setUserRole() {
        this.userRole = this.customerUiService.getUserRole();
    }

    setInvoiceFormatDropdown() {
        this.invoiceFormats = utils.createDropdown(InvoiceFormatEnum, false);
    }

    onInvoiceFormatChange() {
        this.eEmitSelectedInvoiceFormat.emit(this.selectedInvoiceFormat);
    }

    onTypeChange(event) {
        this.printConfig.original = event.checked;
        this.printConfig = JSON.parse(JSON.stringify(this.printConfig));
        this.eEmitChangedPrintType.emit(event.checked);
        this.detectChanges();
    }

    onLetterHeadChange(event) {
        this.printConfig.withLetterHead = event.checked;
        this.printConfig = JSON.parse(JSON.stringify(this.printConfig));
        this.eEmitChangedPrintLetterHead.emit(event.checked);
        this.detectChanges();
    }

    onChildrenVisibilityChange(event) {
        this.printConfig.withChildren = event.checked;
        this.printConfig = JSON.parse(JSON.stringify(this.printConfig));
        this.eEmitChangedChildrenVisibility.emit(event.checked);
        this.detectChanges();
    }

    onAnnexureWithOtherWorksOptionChange(event) {
        this.annexurePrintConfig.withOtherWorks = event.checked;
        this.annexurePrintConfig = JSON.parse(JSON.stringify(this.annexurePrintConfig));
        this.eEmitChangedAnnexureOtherWorks.emit(event.checked);
        this.detectChanges();
    }

    onAnnexureChildrenVisibilityChange(event) {
        this.annexurePrintConfig.withUnits = event.checked;
        this.annexurePrintConfig = JSON.parse(JSON.stringify(this.annexurePrintConfig));
        this.eEmitChangedAnnexureUnitsVisibility.emit(event.checked);
        this.detectChanges();
    }

    savePrintingInstructions() {
        !this.annexureMenu ? this.eEmitSavePrintInstructions.emit(this.printConfig) : this.eEmitSavePrintInstructions.emit(this.annexurePrintConfig);

    }

    previewItems() {
        this.annexureMenu ? this.annexurePrintConfig.preview = true : null;
        !this.annexureMenu ? this.eEmitPreviewPrintItems.emit(this.printConfig) : this.eEmitPreviewPrintItems.emit(this.annexurePrintConfig);
    }

    printItems() {
        this.annexureMenu ? this.annexurePrintConfig.preview = false : null;
        this.eEmitPrintItems.emit(this.printConfig);
    }

    detectChanges() {
        if (!this.changeDetectorRef['destroyed']) {
            this.changeDetectorRef.detectChanges();
        }
    }

}
